import { render } from "./phone-input.vue?vue&type=template&id=1cb960c4&ts=true"
import script from "./phone-input.vue?vue&type=script&lang=ts"
export * from "./phone-input.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/web/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__